var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"alert alert-dismissible notify",class:{
	'alert-danger' : _vm.type === 'error',
	'alert-info' : _vm.type === 'info',
	'alert-success' : _vm.type === 'success',
	'alert-warning' : _vm.type === 'warning'}},[_c('button',{staticClass:"close",attrs:{"type":"button"},on:{"click":function($event){return _vm.close()}}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])]),_c('strong',{staticClass:"title"},[_vm._v(_vm._s(_vm.title))]),_c('br'),_c('span',{domProps:{"innerHTML":_vm._s(_vm.message)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }